import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'redux-little-router';

import { routeMap } from 'router';
import NoData from './private/NoData';
import NoInn from './private/NoInn';
import Unconfirmed from './private/Unconfirmed';
import EsiaError from './private/EsiaError';
import UnknownParameters from './private/UnknownParameters';

export default class InfoPage extends Component {
  static propTypes = {
    router: PropTypes.object.isRequired,
  };

  isTrue = (value) => {
    return value === 'true';
  };

  isFalse = (value) => {
    return value === 'false';
  };

  getContent = () => {
    const {
      router: { query },
    } = this.props;

    if (this.isFalse(query.hasInn)) {
      return <NoInn />;
    } else if (this.isTrue(query.hasInn) && this.isTrue(query.unconfirmed)) {
      return <Unconfirmed />;
    } else if (
      (this.isTrue(query.hasInn) && this.isTrue(query.fidProcessed)) ||
      query.unauthorized === 'pplkWait'
    ) {
      return <NoData />;
    } else if (query.esiaError) {
      return <EsiaError />;
    }

    return <UnknownParameters />;
  };

  render() {
    return (
      <div className="main-page">
        <div className="main-page_bg" />
        <div className="header-wrapper header-wrapper__main">
          <div className="header header__main content">
            <a className="header-title">
              <span className="header-title_icon" />
              <span className="header-title_text">
                Личный кабинет
                <br /> налогоплательщика
              </span>
            </a>
            <div className="header_right">
              <div className="header_links">
                <span
                  className="white"
                  style={{ padding: '0 20px 5px', display: 'inline-block', float: 'right' }}
                >
                  {' '}
                  Контакт-центр
                </span>
                <a href="tel:8-800-222-2222" className="phone">
                  8-800-222-2222
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="main-page_center">
          <div className="main-page_cell">
            <div className="content">
              <div className="main-page_row main-page_row__small">
                <div className="white-block main-page_form">{this.getContent()}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-wrapper">
          <div className="footer footer__main content">
            <div className="footer_left">
              <span className="mobile-hide">
                При наличии вопросов по работе сервиса Вы можете воспользоваться режимом&nbsp;
              </span>
              <Link href={routeMap.faq} className="link white link__underline">
                «Вопрос-ответ»
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
